// extracted by mini-css-extract-plugin
module.exports = {"labelText":"billing-info_labelText__34tLL","valueText":"billing-info_valueText__4DfYT","title":"billing-info_title__1qVqp","simple":"billing-info_simple__36v9h"};